import { RequestHelper } from '@/helper/requestHelper';
import { putRecentTemplateContent, getRecentTemplateContentOf } from '@/data/items-recent';
import { TemplateContent } from '@/data/templateContent/templateContent';

export function getTemplateContent(templateId: number): Promise<TemplateContent> {
    return new Promise((resolve, reject) => {
        RequestHelper.get("get_template_new_content", { id: String(templateId) }, (response) => {
            // オンラインの時はこちら
            const data = JSON.parse(response).data;
            const content = data.templateContents;
            const templateContent = {
                id: templateId,
                content,
                recentUsedAt: Date.now(),
            }
            resolve(templateContent);
            putRecentTemplateContent(templateContent);
        },
        () => {
            // オフラインの時はこちら
            getRecentTemplateContentOf(templateId).then(templateContent => {
                if (!templateContent) {
                    reject('Template Content is not found.');
                }
                resolve(templateContent);
            });
        });
    })
}
